<template>
  <v-container fluid class="theme-color" style="height: 100%;">
    <Default
      class="dialog mb-sm-5"
      :class="{ xs: $vuetify.breakpoint.xsOnly }"
      :accident="accident || ''"
    />
  </v-container>
</template>

<script>
import Default from '../components/add-train/Default.vue';

export default {
  components: {
    Default
  },
  created() {
    this.accident = this.$route.query.data;
  },
  data: () => ({
    accident: ''
  })
};
</script>

<style lang="scss" scoped></style>
